import React, { useState, useEffect } from 'react';
import '../styles/pages/Making.scss';
import '../styles/components/selectbook/Result.scss';
import ArrowButton from '../components/utils/button/ArrowButton';
import { useLocation, json } from 'react-router-dom';

import {
    getBookContents,
    logStorylandReading,
    getStoryLandBookInfo,
} from '../api/LibraryAPI';
import Header from '../components/utils/Header';
import FinalReadingModal from '../components/reading/FinalReadingModal';
import RenderTextWithBreaks from '../components/utils/RenderTextWithBreaks';
import LandScapeModal from '../components/utils/modal/LandScapeModal';
import ErrorModal from '../components/utils/modal/ErrorModal';
import TextToSpeech from '../components/utils/TextToSpeech';
import StoryContentToggle from '../components/utils/StoryContentToggle';
import Flipbook from '../components/flipbook/Flipbook';
import NovelFrame from '../components/flipbook/NovelFrame';
import { AnimatePresence } from 'framer-motion';
import { ERROR } from '../utils/Constants';
import { getLocalizedAssetPath } from '../utils/getLocalizedLogo';

const ReadingbyAIMagkickid = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const USER_ID = queryParams.get('userID');
    const BOOK_ID = queryParams.get('bookID');
    const flag = queryParams.get('flag');

    const [story, setStory] = useState(null);

    const [index, setIndex] = useState(-1);

    const [showFinalReadingModal, setShowFinalReadingModal] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [bgImage, setbgImage] = useState('');
    const [contentText, setcontentText] = useState([]);

    const [bookCover, setBookCover] = useState('');
    const [bookTitle, setBookTitle] = useState('');
    const [bookStyle, setBookStyle] = useState('');

    const [speechState, setSpeechState] = useState(false);
    const [isFlipping, setIsFlipping] = useState(false);
    const [isBookOpened, setIsBookOpened] = useState(false);
    const [showFlipbook, setShowFlipbook] = useState(false);
    const [showTitleOnCover, setShowTitleOnCover] = useState(true);

    const setBookData = (data) => {
        if (!data) return;
        const book = Array.isArray(data) ? data[0] : data;
        console.log('Setting book data:', book);

        setStory(book.contents_json?.story || []);
        setbgImage(book.bookcover || '');
        setcontentText(book.title || '');
        setBookCover(book.bookcover || '');
        setBookTitle(book.title || '');
        setBookStyle(book.style || '');
    };

    const callBookContentsAPI = async () => {
        let res = await getBookContents(BOOK_ID);
        if (res.success) {
            setBookData(res.data);
        }
    };

    const callStorylandAPI = async () => {
        // 1. 로그 기록
        await logStorylandReading(USER_ID, BOOK_ID);
        // 2. 실제 데이터 조회
        let res = await getStoryLandBookInfo(BOOK_ID);
        if (res.success) {
            setBookData(res.data);
        }
    };

    useEffect(() => {
        if (BOOK_ID) {
            localStorage.setItem('book_id', String(BOOK_ID));
        }

        if (flag == 'storyland') {
            callStorylandAPI();
        } else {
            callBookContentsAPI();
        }

        // callLogReadingAPIFunc()
    }, []);

    useEffect(() => {
        if (index === -1) {
            setbgImage(bookCover);
            setcontentText(bookTitle);
            setShowFinalReadingModal(false);
        } else if (story && story[index]) {
            setbgImage(story[index].background || '');
            let contents = story[index].page_content || '';
            if (contents.includes('\\'))
                contents = contents.replaceAll('\\', '');
            contents = contents.split('. ');
            if (contents.length > 1) {
                for (let i = 0; i < contents.length - 1; i++) {
                    contents[i] = contents[i] + '.';
                }
            }
            setcontentText(contents);
            console.log('contentText: ' + contents);
        }
    }, [index]); // []만 쓰면 한번만 호출, [index]면 index가 변할때마다 호출

    const handleButtonClick = (direction) => {
        setIndex((prevIndex) => {
            let newIndex = prevIndex + (direction === 'left' ? -1 : 1);
            if (newIndex < -1) {
                newIndex = (story?.length || 1) - 1;
            } else if (newIndex >= (story?.length || 0)) {
                setShowFinalReadingModal(true);
                return prevIndex;
            }
            console.log('@@ new index => ', newIndex);
            return newIndex;
        });
    };
    // 버튼 클릭 이벤트 전체

    const handleSpeechState = () => {
        if (speechState) {
            setSpeechState(false);
        } else {
            setSpeechState(true);
        }
    };

    return (
        <AnimatePresence>
            <>
                {bookStyle === 'graphic_novel' || bookStyle === '그림 소설' ? (
                    <NovelFrame
                        isFlipping={isFlipping}
                        showLogo={false}
                        isOpened={showFlipbook}
                    >
                        {showFlipbook ? (
                            <div className="flipbook-fade-in-wrapper">
                                <Flipbook
                                    index={index}
                                    story={story || []}
                                    setStory={setStory}
                                    pageCount={story?.length || 0}
                                    setShowFinalModal={setShowFinalReadingModal}
                                    setIsFlipping={setIsFlipping}
                                    handleChangeBackground={null}
                                    setIndex={setIndex}
                                    isReadOnly={true}
                                    title={bookTitle}
                                    cover={bookCover}
                                />
                                <button
                                    className="back-mkid"
                                    onClick={() => {
                                        window.close();
                                    }}
                                >
                                    {' '}
                                    AI매직포유로 돌아가기{' '}
                                </button>
                            </div>
                        ) : (
                            <div
                                className={`book-shelf-cover ${
                                    isBookOpened ? 'opened' : ''
                                }`}
                                onClick={() => {
                                    if (isBookOpened) return;
                                    setIsBookOpened(true);
                                    setTimeout(() => {
                                        setShowFlipbook(true);
                                        setIndex(0);
                                    }, 600);
                                }}
                            >
                                <div className="result-book-container">
                                    <div className="result-book">
                                        <div className="cover-content">
                                            <div className="cover-title-toggle-tabs">
                                                <button
                                                    className={`toggle-tab ${
                                                        showTitleOnCover
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setShowTitleOnCover(
                                                            true
                                                        );
                                                    }}
                                                >
                                                    <img
                                                        src={
                                                            showTitleOnCover
                                                                ? getLocalizedAssetPath(
                                                                      '/images/makingBranch/title-on.svg'
                                                                  )
                                                                : getLocalizedAssetPath(
                                                                      '/images/makingBranch/title-off.svg'
                                                                  )
                                                        }
                                                        alt="제목 보기"
                                                    />
                                                </button>
                                                <button
                                                    className={`toggle-tab ${
                                                        !showTitleOnCover
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setShowTitleOnCover(
                                                            false
                                                        );
                                                    }}
                                                >
                                                    <img
                                                        src={
                                                            showTitleOnCover
                                                                ? getLocalizedAssetPath(
                                                                      '/images/makingBranch/cover-off.svg'
                                                                  )
                                                                : getLocalizedAssetPath(
                                                                      '/images/makingBranch/cover-on.svg'
                                                                  )
                                                        }
                                                        alt="표지 보기"
                                                    />
                                                </button>
                                            </div>
                                            <img
                                                src={bookCover}
                                                alt="cover"
                                            />
                                            <h2
                                                className={`novel-title ${
                                                    !showTitleOnCover
                                                        ? 'hide'
                                                        : ''
                                                }`}
                                            >
                                                {bookTitle}
                                            </h2>
                                        </div>
                                    </div>
                                    <figure className="result-book-left">
                                        <img
                                            src="/images/utils/modal/novelFinalModal/book-left.svg"
                                            alt="spine"
                                        />
                                    </figure>
                                    <figure className="result-book-bottom">
                                        <img
                                            src="/images/utils/modal/novelFinalModal/book-bottom.svg"
                                            alt="pages"
                                        />
                                    </figure>
                                </div>
                                <button
                                    className="back-mkid"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        window.close();
                                    }}
                                >
                                    AI매직포유로 돌아가기
                                </button>
                            </div>
                        )}
                        {showFinalReadingModal && (
                            <FinalReadingModal
                                onBack={() => setIndex(-1)}
                                pageName="aimagickid"
                                onClose={() => {
                                    setShowFinalReadingModal(false);
                                }}
                            />
                        )}
                    </NovelFrame>
                ) : (
                    <section className="stories-section">
                        {showErrorModal && (
                            <ErrorModal
                                error_message={errorMessage}
                                onClose={() => window.close()}
                            ></ErrorModal>
                        )}
                        <figure className="stories-bg">
                            <img
                                src={bgImage}
                                alt="bg-img"
                            />
                        </figure>
                        {index !== -1 && (
                            <ArrowButton
                                onClick={() => handleButtonClick('left')}
                                direction="left"
                                className="story-btn prev-btn"
                            />
                        )}
                        <ArrowButton
                            onClick={() => handleButtonClick('right')}
                            direction="right"
                            className="story-btn next-btn"
                        />
                        <button
                            className="back-mkid"
                            onClick={() => {
                                window.close();
                            }}
                        >
                            AI매직포유로 돌아가기
                        </button>
                        <StoryContentToggle
                            showTitleOnCover={showTitleOnCover}
                            setShowTitleOnCover={setShowTitleOnCover}
                        />
                        <div
                            className={`story-contents-container ${
                                !showTitleOnCover ? 'hide' : ''
                            }`}
                        >
                            <ul
                                className={
                                    typeof contentText === 'string'
                                        ? 'story-contents title'
                                        : 'story-contents'
                                }
                            >
                                {typeof contentText === 'string' ? (
                                    <>
                                        {contentText}
                                        <div className="text-stroke">
                                            {contentText}
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        {contentText.map((sentence, i) => (
                                            <li
                                                key={i}
                                                className="origin-text"
                                            >
                                                {sentence.trim()}
                                                <div className="text-stroke">
                                                    {sentence.trim()}
                                                </div>
                                            </li>
                                        ))}
                                    </>
                                )}
                            </ul>
                        </div>
                        <TextToSpeech
                            text={contentText}
                            speechState={speechState}
                            onChange={handleSpeechState}
                        />
                        <div className="numbering">{index + 1}</div>
                        {showFinalReadingModal && (
                            <FinalReadingModal
                                onBack={() => setIndex(-1)}
                                pageName="aimagickid"
                                onClose={() => {
                                    setShowFinalReadingModal(false);
                                }}
                            />
                        )}
                    </section>
                )}
                <LandScapeModal />
            </>
        </AnimatePresence>
    );
};

export default ReadingbyAIMagkickid;
